export default __webpack_public_path__ + "static/media/Auditorium.75267fa6.jpg";